module.exports = __webpack_public_path__ + "static/media/bogo.ce44700f.jpeg";